import React from 'react'
import Modal from '../../shared/modal'
import Icon from '../../shared/icon'
import { useCatalogue } from '../CatalogueProvider'
import { CatalogueItem } from '../catalogueTypes'
import { t } from '../../../i18n'

const typeName = (item: CatalogueItem): string => (item.class_name === 'Product' ? t('product', { scope: 'product' }) : t('category'))

const DeletionItem = ({ item }: { item: CatalogueItem }) => (
  <>
    <div className="file-placeholder mt-3 mb-1 delete-item-image">
      {item.file_url ? <img src={item.file_url} /> : <Icon name="categoryPlaceholder" className="big-image" />}
    </div>
    <h3 className="mt-3 fw-bold">{item.name}</h3>
  </>
)

const ContinueButton = ({ onClick }: { onClick: () => void }) => (
  <div className="mt-5 mb-5">
    <button type="button" className="btn btn-primary" onClick={onClick}>
      {t('continue')}
    </button>
  </div>
)

const DeleteCatalogueItemDialog = () => {
  const { state, actions, meta } = useCatalogue()
  const { deletion, categoryId, panelUnresolved } = state

  if (!deletion) return null
  const { item } = deletion

  const close = () => {
    if (panelUnresolved) meta.go.browse()
    actions.dismissDelete()
  }

  const body = () => {
    switch (deletion.result) {
      case 'deleted':
        return (
          <>
            <div className="green-check mb-5">
              <Icon name="check" className="mb-1" />
            </div>
            <h3 className="fw-bold">{t('catalogue.delete_dialog.deleted', { type: typeName(item) })}</h3>
            <DeletionItem item={item} />
            <div className="mt-4">
              <div className="text-center">{t('catalogue.delete_dialog.deleted_message', { type: typeName(item) })}</div>
            </div>
            <ContinueButton onClick={close} />
          </>
        )
      case 'failed':
        return (
          <>
            <div className="failed-icon mb-5">
              <Icon name="failed" className="mb-1" />
            </div>
            <h3 className="fw-bold">{t('catalogue.delete_dialog.failed')}</h3>
            <DeletionItem item={item} />
            <div className="mt-4">
              <div className="text-center">
                {t('catalogue.delete_dialog.failed_message', { type: typeName(item), message: deletion.message })}
              </div>
            </div>
            <ContinueButton onClick={close} />
          </>
        )
      case null:
        return (
          <>
            <Icon name="bigDeleteIcon" className="mb-1" />
            <h3 className="mt-4 mb-1 fw-bold">{t('catalogue.delete_dialog.title', { type: typeName(item) })}</h3>
            <DeletionItem item={item} />
            <div className="mt-4">
              <div className="text-center">{t('confirmation.line1')}</div>
              <div className="text-center">{t('confirmation.line2')}</div>
            </div>
            <div className="mt-5 mb-5">
              <button type="button" className="btn btn-primary me-3" onClick={close}>
                {t('cancel')}
              </button>
              <button type="button" className="btn btn-danger" onClick={() => actions.confirmDelete(item, categoryId)}>
                {t('catalogue.delete_dialog.confirm')}
              </button>
            </div>
          </>
        )
    }
  }

  return (
    <Modal onClose={close} widen={true}>
      <div className="d-flex align-items-center justify-content-center flex-column">{body()}</div>
    </Modal>
  )
}

export default DeleteCatalogueItemDialog
